
const Services = () => {
  const services = [
    {
      icon: 'ri-calendar-check-line',
      title: 'Daily Care Programs',
      description: 'Structured daily activities designed to promote physical, mental, and social well-being.',
      features: ['Personalized care plans', 'Health monitoring', 'Medication management', 'Nutritious meals']
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Health & Wellness',
      description: 'Comprehensive health services to maintain and improve overall well-being.',
      features: ['Regular health assessments', 'Physical therapy', 'Wellness programs', 'Medical coordination']
    },
    {
      icon: 'ri-gamepad-line',
      title: 'Recreation & Activities',
      description: 'Engaging activities that stimulate the mind and encourage social interaction.',
      features: ['Arts & crafts', 'Music therapy', 'Games & puzzles', 'Outdoor activities']
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Nutrition Services',
      description: 'Healthy, delicious meals prepared with dietary needs and preferences in mind.',
      features: ['Balanced meal plans', 'Special dietary accommodations', 'Snacks & beverages', 'Nutrition education']
    },
    {
      icon: 'ri-car-line',
      title: 'Transportation',
      description: 'Safe and reliable transportation services for our members.',
      features: ['Door-to-door service', 'Wheelchair accessible', 'Trained drivers', 'Flexible scheduling']
    },
    {
      icon: 'ri-parent-line',
      title: 'Family Support',
      description: 'Resources and support for families navigating senior care decisions.',
      features: ['Family consultations', 'Care coordination', 'Educational resources', 'Support groups']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Comprehensive Care Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our wide range of services is designed to meet the unique needs of each individual, promoting independence while ensuring safety and well-being.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-orange-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <div className="w-2 h-2 bg-orange-600 rounded-full mr-3 flex-shrink-0"></div>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-orange-50 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Personalized Care Plans
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Every member receives a customized care plan developed by our team of professionals. We assess individual needs, preferences, and goals to create a program that promotes independence and enhances quality of life.
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-bold text-orange-600">24/7</div>
                  <div className="text-sm text-gray-600">Care Available</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-orange-600">1:6</div>
                  <div className="text-sm text-gray-600">Staff to Member Ratio</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/245714a3f27ce735ee9f351d09101ddd.jpg"
                alt="Personalized care planning at ProArk Haven"
                className="rounded-xl shadow-lg object-cover w-full h-80"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
